import { useTranslation } from 'react-i18next';
import { Text, Title, type TitleProperties } from 'ui';

type P = {
  hasPrefix?: boolean;
  title: Pick<TitleProperties, 'children' | 'ellipsis' | 'level'>;
};

const EventCanceledTitle = ({
  hasPrefix = true,
  title: { children, ellipsis = { rows: 4, tooltip: true }, level = 2 },
}: P) => {
  const { t } = useTranslation();

  return (
    <Title delete ellipsis={ellipsis} level={level}>
      <Text className="event-canceled-title">
        {hasPrefix ? (
          <Text className="event-canceled-title__prefix" uppercase>
            {t('Canceled:')}{' '}
          </Text>
        ) : null}
        {children}
      </Text>
    </Title>
  );
};

export default EventCanceledTitle;
